module.exports = __webpack_public_path__ + "img/team_teacherback.5384a60f.png";